/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Outlook_Mail_Body_AriaInputs */



/**
* | output |
* | --- |
* | "Email body" |
*
* @param {Chat_Outlook_Mail_Body_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_outlook_mail_body_aria = /** @type {((inputs?: Chat_Outlook_Mail_Body_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Outlook_Mail_Body_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Text der E-Mail")
	return /** @type {LocalizedString} */ ("Email body")
});